import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  Fab,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Backdrop,
} from "@material-ui/core";
// core components
// import Table from "../../components/Table/Table.js";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ReadyMasterAdd from "./ReadyMasterAdd";
import ReadyMasterAddMultiple from "./ReadyMasterAddMultiple";

import { CloudDownload, Search } from "@material-ui/icons";
import * as XLSX from 'xlsx';
import ReadyMasterView from "./ReadyMasterView";
import axios from "axios";
import {
  DeleteAllReadyMasterAPI,
  DeleteReadyMasterAPI,
  GetAllReadyMastersAPI,
} from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import ReadyMasterEdit from "./ReadyMasterEdit";
import Checkbox from "@material-ui/core/Checkbox";
import People from "@material-ui/icons/People";
import CustomInput from "../../components/CustomInput/CustomInput";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { formatINRCurrency } from "../../utils/index.js";

const filterOptions = createFilterOptions({
  matchFrom: "any",
  limit: 500,
});

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(-24),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "productCode", label: "Product Code" },
  { id: "productName", label: "Product Name" },
  { id: "index", label: "Index" },
  { id: "side", label: "Side" },
  { id: "type", label: "Type" },
  { id: "color", label: "Color/ABR" },
  {
    id: "rate",
    label: "Rate",
    format: (value) => {
      const numValue = Number(value);
      if (isNaN(numValue)) return value;
      return numValue.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
    },
  },
  { id: "action", label: "Action" },
];

let pageTypes = ["Normal", "Wide", "Normal * 2", "Wide * 2"];

const addProductTypes = ["Single Product"];

export default function ReadyMasterList(props) {
  const history = useHistory();
  const classes = useStyles();
  let authToken = useSelector((state) => state.userReducer.authToken);
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  const [ready, setReady] = useState([]);
  const [total, setTotal] = useState(null);

  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openPageTypeDialog, setOpenPageTypeDialog] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");

  const [openAddProductTypeDialog, setOpenAddProductTypeDialog] =
    useState(false);
  const [openSingleProductAddDialog, setOpenSingleProductAddDialog] =
    useState(false);
  const [openMultipleProductAddDialog, setOpenMultipleProductAddDialog] =
    useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const readyMastersProducts = useSelector(
    (state) => state.userReducer.readyMasters
  );

  useEffect(() => {
    _getReady();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (searchTerm) {
      searchData(searchTerm);
    }
  }, [page, rowsPerPage]);

  async function _getReady() {
    try {
      console.log("getting ready")
      let res = await axios.get(
        GetAllReadyMastersAPI(userInfo.entity) +
        `&limit=${rowsPerPage}&skip=${page * rowsPerPage}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log("aaya", res.data)
      setReady(res.data.readyMasters);
      setTotal(res.data?.total);
      console.log("readu master", res.data.readyMasters)
    } catch (err) {
      // console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   }); 
    }
  }

  async function _deleteItem(item) {
    try {
      let res = await axios.delete(DeleteReadyMasterAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Successfully Deleted!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getReady();
      // window.location.reload();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   }); 
    }
  }

  async function _deleteAllRecords() {
    try {
      if (_.isEmpty(selectedRows)) {
        return;
      }
      let res = await axios.post(
        DeleteAllReadyMasterAPI(userInfo.entity),
        {
          data: selectedRows,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      // window.location.reload();
      _getReady()
    } catch (e) {
      console.log("err:", e);
    }
  }

  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeSingleProductAddDialog() {
    setOpenSingleProductAddDialog(false);
  }

  function closeMultipleProductAddDialog() {
    setOpenMultipleProductAddDialog(false);
  }

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  async function searchData(term) {
    setIsSearching(true);
    setSearchTerm(term);
    try {
      // Use unified 'search' parameter that searches across productName, productCode, and color
      let url = GetAllReadyMastersAPI(userInfo.entity) +
        `&limit=${rowsPerPage}&skip=${page * rowsPerPage}`;

      if (term && term.trim() !== "") {
        url += `&search=${encodeURIComponent(term)}`;
      }

      let res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setReady(res.data.readyMasters);
      console.log("heo", res.data.readyMasters.length)
      setTotal(res.data.total);
    } catch (err) {
      console.error("Search error:", err);
      toast.error("Search failed. Please try again.", {
        position: "top-center",
        autoClose: 2000,
      });
    } finally {
      setIsSearching(false);
    }
  }

  let data = ready;
  console.log(data, "my data")

  // if (searchTerm !== "") {
  //   data = _.filter(data, (i) => {
  //     return (
  //       i.productCode &&
  //       i.productCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       i.productName &&
  //       i.productName.toLowerCase().includes(searchTerm.toLowerCase())
  //     );
  //   });
  // }

  let excelData = [];
  data.map((i) => {
    let d = [];

    d.push({ value: i.productCode });
    d.push({ value: i.productName });
    d.push({ value: i.index });
    d.push({ value: i.side });
    d.push({ value: i.type });
    d.push({ value: i.color });
    d.push({ value: i.rate });
    d.push({ value: i.sph });
    d.push({ value: i.cyl });
    d.push({ value: i.axis });
    d.push({ value: i.addition });
    d.push({ value: i.quantity });
    excelData.push(d);
  });
  const multiDataSet = [
    {
      columns: [
        { title: "Product Code" },
        { title: "Product Name" },
        { title: "Index" },
        { title: "Side" },
        { title: "Type" },
        { title: "Color/ABR" },
        { title: "rate" },
        { title: "Sph" },
        { title: "Cyl" },
        { title: "Axis" },
        { title: "Addition" },
        { title: "Quantity" },
      ],
      data: excelData,
    },
  ];

  // XLSX Export Function
  const handleExport = async () => {
    setIsExporting(true);
    const loadingToastId = toast.loading('🔄 Preparing export... Please wait', {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });

    try {
      // First, get the total count
      toast.update(loadingToastId, {
        render: '📊 Fetching total record count...',
        type: 'info',
        isLoading: true,
      });

      const totalRes = await axios.get(
        GetAllReadyMastersAPI(userInfo.entity) + `&limit=1&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const total = totalRes.data.total || 0;
      
      if (total === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      // Fetch all data using the total count
      toast.update(loadingToastId, {
        render: `📥 Downloading ${total} records... This may take a moment`,
        type: 'info',
        isLoading: true,
      });

      const res = await axios.get(
        GetAllReadyMastersAPI(userInfo.entity) + `&limit=${total}&skip=0`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      console.log("res>>>>>>", res.status)
      const allData = res.data.readyMasters;
      if (!allData || allData.length === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      toast.update(loadingToastId, {
        render: '⚙️ Processing data for export...',
        type: 'info',
        isLoading: true,
      });

      const exportHeadings = [
        { id: "productCode", label: "Product Code" },
        { id: "productName", label: "Product Name" },
        { id: "index", label: "Index" },
        { id: "side", label: "Side" },
        { id: "type", label: "Type" },
        { id: "color", label: "Color/ABR" },
        { id: "rate", label: "Rate" },
        { id: "sph", label: "Sph" },
        { id: "cyl", label: "Cyl" },
        { id: "axis", label: "Axis" },
        { id: "addition", label: "Addition" },
        { id: "quantity", label: "Quantity" }
      ];

      const exportData = allData.map(row => {
        const rowData = {};
        exportHeadings.forEach(col => {
          let value = row[col.id];
          rowData[col.id] = value;
        });
        return rowData;
      });

      toast.update(loadingToastId, {
        render: '💾 Generating Excel file...',
        type: 'info',
        isLoading: true,
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ReadyMaster');
      XLSX.writeFile(workbook, 'ready_master_export.xlsx');

      toast.update(loadingToastId, {
        render: `✅ Successfully exported ${allData.length} records to Excel!`,
        type: 'success',
        isLoading: false,
        autoClose: 4000,
        style: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } catch (error) {
      console.error('Export error:', error);
      toast.update(loadingToastId, {
        render: `❌ Export failed: ${error.response?.data?.message || error.message || 'Unknown error'}`,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        style: {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  const PageTypeDialog = () => {
    return (
      <Dialog
        onClose={() => setOpenPageTypeDialog(false)}
        aria-labelledby="simple-dialog-title"
        open={openPageTypeDialog}
      >
        <DialogTitle id="simple-dialog-title">Select Page Type</DialogTitle>
        <List>
          {pageTypes.map((item) => (
            <ListItem
              button
              onClick={() => {
                setOpenPageTypeDialog(false);
                let tmp = [];
                selectedRows.map((o) => {
                  let obj = _.find(data, { _id: o });
                  tmp.push(obj);
                });
                history.push("/admin/product-barcodes", {
                  products: tmp,
                  pageType: item,
                });
              }}
              key={item}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  };

  const AddProductDialog = () => {
    return (
      <Dialog
        onClose={() => setOpenAddProductTypeDialog(false)}
        aria-labelledby="simple-dialog-title"
        open={openAddProductTypeDialog}
      >
        <DialogTitle id="simple-dialog-title">
          Select Add Product Method
        </DialogTitle>
        <List>
          {addProductTypes.map((item) => (
            <ListItem
              button
              onClick={() => {
                setOpenAddProductTypeDialog(false);
                if (item === "Single Product") {
                  setOpenSingleProductAddDialog(true);
                } else {
                  setOpenMultipleProductAddDialog(true);
                }
              }}
              key={item}
            >
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>
      </Dialog>
    );
  };
  function handleSearch() {
    searchData(search);
  }
  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Button
          color="primary"
          onClick={() =>
            handleOpenConfirmationModal({
              msg: "Do you want to delete all records",
              onPress: () => _deleteAllRecords(),
            })
          }
        >
          Delete All Records
        </Button>

        <Box justifyContent={"center"} alignItems={"center"}>
          <Button
            color="primary"
            onClick={() =>
              handleOpenConfirmationModal({
                title: "Print barcode",
                msg: "Do you want to print barcodes?",
                onPress: () => setOpenPageTypeDialog(true),
              })
            }
          >
            Print Barcodes
          </Button>
          <Tooltip title={"Export to excel"}>
            <IconButton
              color={"primary"}
              onClick={handleExport}
              disabled={isExporting}
            >
              <CloudDownload />
            </IconButton>
          </Tooltip>
          <CustomInput
            id="search"
            formControlProps={{
              fullWidth: false,
            }}
            inputProps={{
              style: {
                color: "primary",
                marginTop: 0,
              },
              placeholder: "Search (Product, Code, Color/ABR)",
              value: search,
              onChange: (e) => {
                setSearch(e.target.value);
                if (e.target.value === "" || e.target.value === null) {
                  _getReady();
                }
              },
              onKeyDown: (e) => {
                if (e.keyCode === 13) {
                  e.preventDefault();
                  handleSearch();
                }
              },
              endAdornment: (
                <InputAdornment position="end">
                  {isSearching ? (
                    <CircularProgress size={24} style={{ marginRight: 8 }} />
                  ) : (
                    <IconButton color={"primary"} onClick={handleSearch}>
                      <Search />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
          />
          <IconButton
            aria-label="add"
            onClick={() => setOpenAddProductTypeDialog(true)}
          >
            <AddIcon />
          </IconButton>
        </Box>
      </Box>
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <Checkbox
              style={{
                color: "#512da8",
              }}
              onChange={(e) => {
                let c = [];
                if (e.target.checked) {
                  data.map((i) => {
                    c.push(i._id);
                  });
                }
                setSelectedRows(c);
              }}
              checked={
                selectedRows.length > 0 && data.length === selectedRows.length
              }
              inputProps={{ "aria-labelledby": -1 }}
            />
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={"center"}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isSearching && data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length + 1} align="center" style={{ padding: "40px" }}>
                <CircularProgress />
                <Box style={{ marginTop: "16px", color: "#666" }}>
                  Searching...
                </Box>
              </TableCell>
            </TableRow>
          ) : (
            data
              // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      style={{
                        color: "#512da8",
                      }}
                      onChange={() => {
                        let copy = _.clone(selectedRows);
                        if (_.includes(copy, row._id)) {
                          let index = _.indexOf(copy, row._id);
                          copy.splice(index, 1);
                        } else {
                          copy.push(row._id);
                        }
                        setSelectedRows(copy);
                      }}
                      checked={_.includes(selectedRows, row._id)}
                      inputProps={{ "aria-labelledby": row._id }}
                    />
                  </TableCell>
                  {columns.map((column) => {
                    let value = row[column.id];
                    if (column.id === "discountedProducts") {
                      value = !_.isEmpty(row.data) ? row.data.length : 0;
                    }
                    if (column.id === "action") {
                      return (
                        <TableCell align={"center"}>
                          <Box display={"flex"} justifyContent={"center"}>
                            <IconButton
                              aria-label="view"
                              onClick={() =>
                                setOpenViewDialog({
                                  open: true,
                                  item: row,
                                })
                              }
                            >
                              <VisibilityIcon />
                            </IconButton>
                            <IconButton
                              aria-label="edit"
                              onClick={() =>
                                setOpenEditDialog({
                                  open: true,
                                  item: row,
                                })
                              }
                            >
                              <EditIcon />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                handleOpenConfirmationModal({
                                  msg: "Do you want to delete this record?",
                                  onPress: () => _deleteItem(row),
                                })
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Box>
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell key={column.id} align={"center"}>
                        {column.format && (typeof value === "number" || !isNaN(Number(value)))
                          ? column.format(Number(value))
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {/*<Fab color="primary" aria-label="add" className={classes.fab}*/}
      {/*     onClick={() => setOpenAddDialog(true)}>*/}
      {/*    <AddIcon/>*/}
      {/*</Fab>*/}

      <PageTypeDialog />
      <AddProductDialog />
      <ReadyMasterAdd
        fetchData={_getReady}
        open={openSingleProductAddDialog}
        close={closeSingleProductAddDialog}
      />
      <ReadyMasterAddMultiple
        fetchData={_getReady}
        open={openMultipleProductAddDialog}
        close={closeMultipleProductAddDialog}
      />
      {openViewDialog ? (
        <ReadyMasterView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openEditDialog ? (
        <ReadyMasterEdit
          open={openEditDialog.open}
          close={closeEditDialog}
          item={openEditDialog.item}
          fetchData={_getReady}
        />
      ) : null}
      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={"Delete Record"}
          msg={openConfirmationModal.msg}
        />
      ) : null}
      <Backdrop
        open={isExporting}
        style={{
          zIndex: 9999,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={60} thickness={4} style={{ color: '#512da8', marginBottom: 20 }} />
          <Box style={{ fontSize: '18px', fontWeight: 'bold', marginTop: 10 }}>
            Exporting Data...
          </Box>
          <Box style={{ fontSize: '14px', marginTop: 5, opacity: 0.8 }}>
            Please wait while we prepare your Excel file
          </Box>
        </Box>
      </Backdrop>
    </>
  );
}
